import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMedia } from 'react-use';
import { LazyLoadImage, LazyLoadSource } from 'ck-ui';
import { getSanityImg } from 'src/sanityClient';
import { getPromoName, trackPromotionClick } from '../utils';
import { usePromotionView } from '../hooks';
import { ModalLink } from '../../ModalLink';
import styles from './Heros.module.scss';

const Hero = ({ handle, blockHeroImage, position }) => {
  const { title, modal, isFullScreen, trackingID, mobileImage, desktopImage, link } = blockHeroImage;
  const isMobile = useMedia('(max-width: 767px)');
  const ref = useRef(null);
  const desktopImgUrl = useMemo(() => getSanityImg(desktopImage._id).auto('format').url(), [desktopImage._id]);
  const mobileImgUrl = useMemo(() => getSanityImg(mobileImage._id).auto('format').url(), [mobileImage._id]);
  const promo = {
    id: handle,
    name: getPromoName(handle, trackingID || title || link),
    creative: isMobile ? mobileImgUrl : desktopImgUrl,
    position: `${handle}-${position}`
  };
  const heroLink = (
    <a
      data-modal-toggle={modal?.id}
      href={link}
      onClick={() => trackPromotionClick(promo)}
      className="image-wrapper"
      style={{ paddingBottom: `calc(${isMobile ? mobileImage.height / mobileImage.width : desktopImage.height / desktopImage.width} * 100%)` }}
      title={title}
    >
      {position === 0 && <link rel="preload" href={isMobile ? mobileImgUrl : desktopImgUrl} as="image" />}
      <picture>
        <LazyLoadSource
          media="(max-width: 767px)"
          srcSet={mobileImgUrl}
        />
        <LazyLoadSource
          media="(min-width: 768px)"
          srcSet={desktopImgUrl}
        />
        <LazyLoadImage
          className={styles.img}
          src={desktopImgUrl}
          alt={title}
        />
      </picture>
    </a>
  );

  usePromotionView([promo], ref);

  return (
    <section ref={ref} className={classnames('home-section', { [styles.root]: isFullScreen })}>
      {!isFullScreen ? (
        <div className="container">
          <div className="columns">
            <div className="column">
              {heroLink}
            </div>
          </div>
        </div>
      ) : heroLink}
      {modal?.id && (
        <ModalLink id={modal.id} title={modal.title} links={modal.links} description={modal.description} />
      )}
    </section>
  );
};

Hero.propTypes = {
  blockHeroImage: PropTypes.object.isRequired,
  handle: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired
};

export { Hero };
